import Vue from 'vue';
import { optionTag, selectorDatasetTag } from './config';

/**
 * Method get selector id for e2e based on name or options
 *
 * @param componentInstance
 * @returns {string}
 */
function getDatasetSelectorId(componentInstance) {
    const instanceE2EOptions = componentInstance.$options[optionTag];
    const componentName = componentInstance.$options.name;
    const componentId = componentInstance.testId;

    return (instanceE2EOptions instanceof Object)
        ? componentId || instanceE2EOptions.selectorId || componentName
        : componentId || componentName;
}

/**
 * Method set properly dataset on component instance
 *
 * @param {vue} componentInstance
 * @param {string} selectorId
 */
function setSelectorId({ $el }, selectorId) {
    $el.dataset[selectorDatasetTag] = selectorId;
}

const plugin = {
    install: (VueInstance) => {
        if (process.env.handleE2E) {
            /**
             * Add mixin for all instances vue
             */
            VueInstance.mixin({
                /**
                 * Method for vue lifecycle which check component instance has e2e option
                 * if it has run method which add dataset for e2e
                 */
                props: {
                    /**
                     * Test id
                     */
                    testId: {
                        type: String,
                        default: undefined,
                    },
                },
                mounted() {
                    if (this.$options[optionTag] && this.$vnode) {
                        const selectorId = getDatasetSelectorId(this);
                        setSelectorId(this, selectorId);
                    }
                },
            });
        }
    },
};

Vue.use(plugin);

export default plugin;
